/* eslint-disable no-undef */
const initLTLEmbeddedMessaging = () => {
  const {
    REACT_APP_LTL_SALESFORCE_EMBEDDED_CHANNEL_ID,
    REACT_APP_LTL_SALESFORCE_EMBEDDED_CHANNEL_NAME,
    REACT_APP_LTL_SALESFORCE_EMBEDDED_CHANNEL_URL,
    REACT_APP_SALESFORCE_EMBEDDED_SCRT2URL
  } = process.env;
  try {
    window.embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'
    window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;
    window.embeddedservice_bootstrap.init(
      REACT_APP_LTL_SALESFORCE_EMBEDDED_CHANNEL_ID,
      REACT_APP_LTL_SALESFORCE_EMBEDDED_CHANNEL_NAME,
      REACT_APP_LTL_SALESFORCE_EMBEDDED_CHANNEL_URL,
      {
        scrt2URL: REACT_APP_SALESFORCE_EMBEDDED_SCRT2URL
      }
    );
  } catch (err) {
    console.error('Error loading Embedded Messaging: ', err);
  }
};

export default initLTLEmbeddedMessaging;
